export default "__VITE_ASSET__khlRqjZO__"